import events from 'events.js';

(async () => {
    await events.ready();

    const ua = window.navigator.userAgent;
    const uaField = document.getElementById('useragent');
    uaField.value = ua;

    window.submitContactForm = function (token) {
        const ctField = document.getElementById('captcha_token');
        ctField.value = token;
        document.getElementById('contact_form').submit();
    };
})();
